module.exports = __webpack_public_path__ + "img/modulo_Benefit.5562cfa.svg";